import { css } from "theme/default/css";

export const setFlexJCC = css`
  justify-content: center;
`;
